<template>
  <div class="uk-width-1-4@s uk-width-1-1 bg_gray">
    <div class="uk-section uk-padding-small">
      <div class="uk-text-center f26 uk-margin-large-top">
          <router-link :to="{ name: 'Home' }" class="text_black">
            戻る
          </router-link>
      </div>
    </div>
  </div>
</template>
